import { Component, h } from '@stencil/core';

@Component({
    tag: 'kdx-hero-carousel',
    styleUrl: 'kdx-hero-carousel.scss'
})
export class KdxHeroCarousel {    

    render() {
        return (
            <section class="kdx-hero-carousel" aria-label="hero carousel">
                <slot />
            </section>
        );
    }
}
